import { LogConfig, LogLevel, LogTargetBase, NullTarget } from '@kpmg-tax/core';
import { environment } from '../../../environments/environment';

export const LOG_SETTINGS_CONFIG: LogConfig = {
    logLevel: environment.logLevel,
    logToConsole: !environment.production,
    logTarget: { provide: LogTargetBase, useClass: NullTarget },
    appIdentifier: 'RDE-APP'
};
